import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import './Sidebar.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import FontAwesome

const MobileNav = ({ user, setUser }) => {
    // Function to handle user logout
    const handleLogout = () => {
        signOut(auth)
            .then(() => {
                setUser(null); // Clear user state on successful logout
            })
            .catch((error) => {
                console.error('Error logging out: ', error); // Log any errors
            });
    };



    return (
        // Sidebar container with dynamic class based on isOpen prop
        <div className="sideCover">

            <div>
                This System is not supported by your device, please use Landscape mode or connect to a PC.
                {/* Logout button */}
                <button onClick={handleLogout} className="logout-button">Logout</button>
            </div>
        </div>
    );
};

export default MobileNav;
